// export const useCrypto = () => {
//     const [cryptoMessage, setCryptoMessage] = useState('')
//     // const cryptoMessageRef = useRef('')
//     // return cryptoMessageRef
//     const handleSetCryptoMessage = (token) => {
//         const crypto = new FixedEncryption('cenbo_czr');
//         const ciphertext = crypto.encrypt(token);
//         console.log('ciphertext', ciphertext)
//         setCryptoMessage(ciphertext)
//     }
//     return { cryptoMessage, handleSetCryptoMessage }
// }

import { create } from 'zustand';
import FixedEncryption from '@/utils/crypto';

export const useCryptoStore = create((set) => ({
  // cryptoMessage: '',
  // handleSetCryptoMessage: (token) => {
  //   const crypto = new FixedEncryption('cenbo_czr');
  //   const ciphertext = crypto.encrypt(token);
  //   set({ cryptoMessage: ciphertext });
  // },
  handleGetCryptoMessage: (userIdMessage) => {
    try {
      const crypto = new FixedEncryption('cenbo_czr');
      const ciphertext = crypto.decrypt(userIdMessage);
      return ciphertext;
    } catch (error) {
      return null
    }
  },
}));

// // 使用示例
// const crypto = new FixedEncryption('cenbo_czr');

// // 多次加密相同内容，结果相同
// const ciphertext1 = crypto.encrypt('my message');
// const ciphertext2 = crypto.encrypt('my message');
// const ciphertext3 = crypto.encrypt('my message');

// console.log('ciphertext1:', ciphertext1);
// console.log('ciphertext2:', ciphertext2);
// console.log('ciphertext3:', ciphertext3);
// console.log('全部相同:', ciphertext1 === ciphertext2 && ciphertext2 === ciphertext3);

// // 解密验证
// const decrypted = crypto.decrypt(ciphertext1);
// console.log('解密结果:', decrypted);